import React from 'react';
import Overview from './sections/Overview';

const Solutions = () => {
  return <Overview />;
};

export default Solutions; 